
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function CommunityTotalParticipantsHeader() {
	return (
		<StickyNumericHeader
			style={{
				...offsetOneRow,
				width: '160px',
				minWidth: '160px',
				maxWidth: '160px'
			}}>
			Community total participants
		</StickyNumericHeader>
	)
}

export function CommunityTotalParticipantsFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunityNumberOfTotalParticipantsValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunityNumberOfTotalParticipantsValidated: e.value
						})
					}
				/>
				<NumericFilter
					value={filter?.CommunityNumberOfTotalParticipants ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunityNumberOfTotalParticipants: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function CommunityTotalParticipantsContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject
						.CommunityNumberOfTotalParticipantsValidated && (
							<ValidatedIcon />
						)}
				</span>
				<span>
					{ppn.PlantingProject.CommunityNumberOfTotalParticipants?.toLocaleString()}
				</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}